<template>
<el-card :class="$style.myelcard" shadow="hover">
	<div class="dflex fw500">
	    <div class="f1">
	        <div :class="$style.pic">
	            <!-- <img :src="item['head_portrait']" alt="" class="button" :class="$style.img" @click="onDetailClick"> -->
				<img v-show="videoId != ''" :class="$style.playerButton" src="../assets/youtube.png"  @click="playYoutubeVideo" >
				<img :src="item['head_portrait']" alt=""  :class="$style.img">
	        </div>
	        <div class="fs1 gray" :class="$style.lb">
	            <div class="dflex" :class="$style.fs" style="margin: 8px 0px 5px;">
	                <span style="margin-left: 28px;font-size: 16px;">{{$t('status')}}</span>
	                <span class="f1"></span>
	                <span 
	                    :class="$style.state" 
	                    :notavail="!item['available_status']" 
	                    class="white fs14" 
	                    style="padding: 0px 10px;border-radius: 5px;">
	                        {{!!item['available_status'] ? $t('available') : $t('notavailable')}}
	                </span>
	            </div>
				<div class="dflex" style="margin: 8px 0px 5px;" :class="$style.fs">
				    <!-- <el-checkbox :key="item['code']" :label="item['code']" >{{ '' }}</el-checkbox> -->
				    <span class="f1 right"><el-link type="primary" @click="onDetailClick">{{$t('more')}}>></el-link></span>
				</div>
	            <!-- <div class="dflex" style="margin: 10px;">
	                <span class="f1"></span>
	                <el-button type="primary" round @click="onClickRemove">{{ $t('remove') }}</el-button>
	            </div> -->
	        </div>
	    </div>
	    <div :class="$style.right">
	        <p v-for="labt in list" :key="labt.label" class="dflex" :class="$style.mlabel">
	            <span class="f1 gray">{{labt.label}}</span><span class="gray">:</span>
				<span :class="$style.value">
					{{labt.value}}
					<!-- <el-button 
					v-show="labt.key == 'interview_at' && item['interview_status'] == 0" 
					type="warning" 
					@click="showReset"
					round >{{ $t('interH9') }}</el-button> -->
				</span>
	        </p>
			<!-- <div v-if="item.interview_status == 1" class="dflex" style="margin: 10px;"> -->
	    </div>
	</div>
	<div class="dflex" style="margin: 10px;justify-content: center;">
		<el-button :class="$style.btcolor" round @click="onClickRemove">{{ $t('remove') }}</el-button>
	    <el-button class="showInLargeb" type="warning" round @click="onClickConfirm">{{ $t('confirmInterview') }}</el-button>
		<el-button class="showInSmall" type="warning" round @click="onClickConfirmInSmall">{{ $t('confirmInterview') }}</el-button>
	</div>
</el-card>
</template>
<script>


export default {
    name: 'Card',
    props: {
        item: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            // hearturl: ''
			resetDate:'',
			resetTime:'',
			centerDialogVisible: false,
			videoId:this.item['youtube_video_id'],
        }
    },
    computed: {
        list() {
            return [
                {label: this.$t('interH1'), value: this.item.code,key :"code"},
                {label: this.$t('interH2'), value: this.item.name,key :"name"},
                {label: this.$t('interH3'), value: this.item.mobile,key :"mobile"},
                {label: this.$t('interH4'), value: this.item.interview_at,key :"interview_at"},
                {label: this.$t('interH5'), value: this.item.interview_status == 0 ? this.$t('interH8') : this.$t('interH7'),key :"interview_status"},
                {label: this.$t('interH6'), value: this.item.interview_result, key:"interview_result"},
            ];
        },
    },
    inject:["loadingHistory","showResetDialog"],
    methods: {
		playYoutubeVideo(){
			this.$emit('setYoutubeVideoId',this.videoId)
		},
		showReset(){
			this.showResetDialog(this.item);
		},
        onDetailClick() {
            this.$router.push('/detail/' + this.item.code);
			// let  toTaskLog = this.$router.resolve({path: '/detail/' + this.item.code});
			// window.open(toTaskLog.href,'_blank');
        },
        onClickRemove(){
            this.$service.removeInterviewHistory({id: this.item.id}).then(() => {
                // this.$set(this.item, 'is_favorite', !this.item['is_favorite']);
                this.$forceUpdate();
				this.loadingHistory();
            });
        },
		onClickConfirm(){
			this.$service.interviewSetConfirmInfo({id: this.item.id}).then(()=>{
				let  toTaskLog = this.$router.resolve({path: '/newpayment'});
				window.open(toTaskLog.href,'_blank');
			}).catch((res = {}) => {
				this.$message({
				  message: res.message || 'something error',
				  type: 'error',
				  offset: 350,
				});
			});
		},
		onClickConfirmInSmall(){
			this.$service.interviewSetConfirmInfo({code: this.item.code}).then(()=>{
				this.$router.push('/newpayment');
			}).catch((res = {}) => {
				this.$message({
				  message: res.message || 'something error',
				  type: 'error',
				  offset: 350,
				});
			});
		},
    }
}
</script>
<style module>
.myelcard {
	width: 790px !important;
}
.btcolor {
    background-color: #778899 !important;
	color: #fff !important;
}
.gridright {
  height: 5rem;
  text-align: right;
  line-height: 4rem;
  font-size: 1rem;
}
.mydatetime{
	top: 610px !important;
}
.mydate{
	top: 140px !important;
	left: 590px !important;
}
.btcolor {
    background-color: #778899 !important;
	color: #fff !important;
}
.state {
    background: #29bd7a;
}
.state[notavail] {
    background: #ec2626;
}
.playerButton {
	width: 2.5rem;
	height: 2.5rem;
	position: absolute;
	left: 10px;
	bottom: 10px;
	cursor: pointer;
}
.pic {
    width:200px;
    height:260px;
	position: relative;
}
.right {
    font-size: 18px;
    line-height: 1.5;
    flex:1.5;
    padding-left: 20px;
    margin-right: 50px;
}
.value {
    flex: 1.5;
    padding-left: 10px;
}
.lb {
    width: 200px;
}
.heart {
    vertical-align: -3px;
    width:18px;
}
.img {
    width: 200px;
    height: 260px;
}
.mlabel {
	margin-bottom: 20px;
}
@media screen and (max-width: 770px) {
	.mlabel {
		margin-bottom: 5px;
	}
    .pic {
        width:150px;
        height:200px;
		margin-bottom: 25px;
    }
    .img {
        width: 150px;
        height:200px;
    }
    .right {
        font-size: 14px;
        flex:1.5;
        padding-left: 10px;
        margin-right: 0px;
    }
    .value {
        flex: 4;
    }
    .lb {
        width: 150px;
    }
    .fs {
        font-size: 12px;
    }
	.mydatetime{
		top: 568px !important;
	}
	.mydate{
		top: 180px !important;
		left: 30px !important;
		width: 100%;
	}
}
</style>
